import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Observable, Subscription } from 'rxjs';
import { shortenString } from 'src/app/helpers/shorten-string.helper';

import { TCenter } from '@shared/interfaces/TCenter';

import { IPaginationParams } from 'src/app/components/common-table/pagination/pagination.component';
import { calculatePercent } from 'src/app/helpers/calculate-percent-helper';
import { AccountsTableDataItem } from 'src/app/interfaces/accounts-table-data.interface';
import { Region } from 'src/app/interfaces/region.interface';
import { CategoriesService } from 'src/app/services/categories.service';
import { CentersService } from 'src/app/services/centers.service';
import { PagingService } from 'src/app/services/paging.service';
import { KamReportsService } from '../../services/kam-reports.service';

@Component({
  selector: 'app-accounts',
  templateUrl: './accounts.component.html',
  styleUrls: ['./accounts.component.scss']
})
export class AccountsComponent implements OnInit {

  @Input() projectId: string;

  // settings for accounts table
  @ViewChild(MatSort) accountsSort: MatSort;
  @ViewChild(MatPaginator) accountsPaginator: MatPaginator;
  public accounts: AccountsTableDataItem[] = [];
  public accountsDataSource: MatTableDataSource<AccountsTableDataItem>;
  public accountsDisplayedColumns: string[] = [
    'account',
    'patientPotentialKam',
    'patientPotentialIqvia',
    'percentOfPatientsPotentialKam',
    'patientUtilisationKam',
    'percentOfPatientPotentialKam',
    'utilisation',
    'percentOfPatientUtilisationKam'
  ];
  // private accountsSortParams: SortParams[] = [];
  public accountsPaginationParams: IPaginationParams;
  private subscriptions: Subscription[] = [];

  constructor(
    private _centersService: CentersService,
    private _pagingService: PagingService,
    private _kamReportsService: KamReportsService,
    private _categoriesService: CategoriesService,
  ) {}

  get centers$(): Observable<TCenter[]> { return this._kamReportsService.allCenters$; }
  get selectedRegions$(): Observable<Region[]> { return this._kamReportsService.selectedRegions$; }


  ngOnInit(): void {
    this.subscriptions.push(
      this.centers$.subscribe((centers: TCenter[]) => {
        // console.log('## CENTERS sub', centers);
        this.accountsDataSource = new MatTableDataSource<AccountsTableDataItem>([]);
        centers.forEach(center => {
          this.accounts.push(this.buildAccountsTableDataItem(center));
        });
        this.accountsDataSource.data = this.accounts;
        this.accountsPaginationParams = {
          length: this.accounts.length,
          pageIndex: 0,
          pageSize: 10,
          pageSizeOptions: this.getPageSizeOptions(this.accounts.length),
          handlePageCallback: this.accountsPageChangeEvent,
        };
      }),
    );
  }

  ngAfterViewInit() {
    this.accountsDataSource.paginator = this.accountsPaginator;
    this.accountsDataSource.sort = this.accountsSort;
  }

  /**
   * Bild data item for Centers table
   * @param  {TCenter} center
   * @returns AccountsTableDataItem
   */
  buildAccountsTableDataItem(center: TCenter): AccountsTableDataItem {
    const centerProjectsData = center.projectsData.filter(pd => pd.projectId === this.projectId)[0];
    const result =  {
      // account: shortenString(center.c_name || center.c_original_name, 40),
      account: center.c_name || center.c_original_name,
      patientPotentialKam: centerProjectsData?.c_proj_patient_potential1,
      patientPotentialIqvia: centerProjectsData?.c_proj_patient_potential2,
      percentOfPatientsPotentialKam: calculatePercent(centerProjectsData?.c_proj_patient_potential2, centerProjectsData?.c_proj_patient_potential1),
      patientUtilisationKam: centerProjectsData?.patient_utilisation1,
      percentOfPatientPotentialKam: calculatePercent(centerProjectsData?.patient_utilisation1, centerProjectsData?.c_proj_patient_potential1),
      utilisation: centerProjectsData?.sales_patient_equivalents,
      percentOfPatientUtilisationKam: calculatePercent(centerProjectsData?.sales_patient_equivalents, centerProjectsData?.patient_utilisation1),
    };
    return result;
  }

  // update data on page change
  accountsPageChangeEvent(event: PageEvent) {
    this.accountsPaginationParams = {
      ...this.accountsPaginationParams,
      pageSize: event.pageSize,
      pageIndex: event.pageIndex,
    };
  }


  // get pagination size options for accounts table
  getPageSizeOptions(length: number): number[] {
    return this._pagingService.getPageSizeOptions(length);
  }

  shorten(str: string, len: number): string {
    return shortenString(str, len);
  }

  public getHeader(field: string): string {
    return this._categoriesService.getFieldDescription(field, this.projectId);
  }

}
